<template>
  <a-modal
      :visible="showLoginModal"
      @cancel="_changeLoginModal(false)"
      :footer="null"
      width="360px"
      :bodyStyle="bodyStyle"
  >
    <div class="login-modal">
      <div class="login-detail">

        <a-menu slot="title" v-model="current" mode="horizontal" @click="changeMenuItem">
          <a-menu-item key="1"> 普通登录</a-menu-item>
          <a-menu-item key="2"> 手机登录</a-menu-item>
        </a-menu>

        <a-form v-if="!isPhoneLogin"
                :form="form"
                class="login-form"
                @submit="handleSubmit"
        >
          <a-form-item>
            <a-input
                v-decorator="['userName',{ rules: [{ required: true, message: '请输入账户名!' }] },]"
                placeholder="请输入账户名"
            >
              <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)"/>
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
                v-decorator="['password', { rules: [{ required: true, message: '请输入密码!' }] },]"
                type="password"
                placeholder="请输入密码"
            >
              <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)"/>
            </a-input>
          </a-form-item>
          <a-form-item class="login-form-action">
            <!--                        <a-checkbox-->
            <!--                                v-decorator="['remember',{valuePropName: 'checked',initialValue: true,},]"-->
            <!--                        >-->
            <!--                            记住密码-->
            <!--                        </a-checkbox>-->

            <a-button style="width: 100%" type="primary" html-type="submit" :loading="loading"
                      class="login-form-button">
              登录
            </a-button>

            <a class="login-form-forgot" @click="_changeForgotPasswordModal(true)" href="#">
              忘记密码?
            </a>
            <a class="register" @click="_changeRegisterModal(true)">立即注册!</a>
          </a-form-item>
        </a-form>

        <a-form v-if="isPhoneLogin"
                :form="form"
                class="login-form"
                @submit="phoneHandleSubmit"
        >
          <a-form-item>
            <a-input
                v-decorator="['mobile',{ rules: [{ required: true, message: '请输入手机号!' },{ pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误' }] },]"
                placeholder="请输入手机号"
            >
              <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)"/>
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
                v-decorator="['code', { rules: [{ required: true, message: '请输入验证码!' }] },]"
                type="password"
                placeholder="请输入验证码"
                style="width: 55%"
            >
              <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)"/>
            </a-input>

            <a-button @click="phoneSendCode" :disabled="show" type="primary"
                      style="width: 40%;margin-left: 10px;border-radius: 6px">{{ countText }}
            </a-button>
          </a-form-item>

          <a-form-item class="login-form-action">
            <a-button style="width: 100%" type="primary" html-type="submit" :loading="loading"
                      class="login-form-button">
              登录
            </a-button>

            <a class="login-form-forgot" @click="_changeForgotPasswordModal(true)" href="#">
              忘记密码?
            </a>
            <a class="register" @click="_changeRegisterModal(true)">立即注册!</a>
          </a-form-item>
        </a-form>
      </div>

    </div>
  </a-modal>
</template>

<script>
import common from "../../mixin/common";
import {createNamespacedHelpers} from "vuex";
import {login, loginMobile, loginSendCode} from "@api/personal-api";
import {showSuccessMsg, showWaringMsg} from "@utils/msg";
import {DISPATCH_INIT_USER_INFO} from "@constants/action-type/login-action-type";

const {mapState} = createNamespacedHelpers('login');
export default {
  name: "LoginModel",
  mixins: [common],
  computed: {
    ...mapState(['showLoginModal'])
  },
  data() {
    return {
      bodyStyle: {
        padding: '20px 36px 24px'
      },
      //默认选中
      current: ['1'],
      //    控制选择登录方式
      isPhoneLogin: false,
      //    登录需要数据
      username: "1",
      password: "1",
      rememberMe: false,
      //    验证码倒计时
      show: false,
      count: 0,
      countText: "获取验证码",
      timer: null,
      newUserInfo: {
        mobile: ""
      },
      //    点击登录，加载中效果
      loading: false,
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, {name: 'normal_login'});
  },
  methods: {
    changeMenuItem(item) {
      if (item.key == 1) {
        this.isPhoneLogin = false
      } else if (item.key == 2) {
        this.isPhoneLogin = true
      }
    },
    //    登录
    handleSubmit(e) {
      e.preventDefault();
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          login(values.userName, values.password,this.$route.query.memberRegistrationLinkCode || '' ,false).then((res) => {
            console.log(res)
            if (res.code === 0) {
              this.loading = false
              showSuccessMsg('登录成功，欢迎回来！');
              // 设置vuex的值
              this.$store.dispatch(DISPATCH_INIT_USER_INFO)
              this._changeLoginModal(false);
            } else if (res.code === 500) {
              this.loading = false
              showWaringMsg(res.msg);
            } else {
              this.loading = false
            }
          })
        } else {
          this.loading = false
        }
      });
    },
    //获取验证码
    phoneSendCode() {
      this.show = true;
      this.form.validateFields((err, values) => {
        let phoneChecking = /^1[3456789]\d{9}$/
        if (!phoneChecking.test(values.mobile)) {
          showWaringMsg('手机号格式不正确，请重新输入！');
          this.show = false;
          return false;
        } else {
          //    60秒倒计时
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            // this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.show = true;
                this.count--;
                this.countText = this.count + "s后重试"
              } else {
                this.show = false;
                clearInterval(this.timer);
                this.timer = null;
                this.countText = "获取验证码"
              }
            }, 1000)
          }
          loginSendCode(values.mobile).then((res) => {
            if (res.code == 0) {
              showSuccessMsg('发送成功，注意查收并正确填写验证码');
            } else {
              // showWaringMsg(res.msg);
              this.show = false;
              clearInterval(this.timer);
              this.timer = null;
              this.countText = "获取验证码"
            }
          })
        }
        // }
      });

    },
    //手机登录
    phoneHandleSubmit(e) {
      e.preventDefault();
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          loginMobile(values.mobile, values.code, this.$route.query.memberRegistrationLinkCode || '' ,false).then((res) => {
            if (res.code === 0) {
              this.loading = false
              showSuccessMsg('登录成功，欢迎回来！');
              this.$store.dispatch(DISPATCH_INIT_USER_INFO)
              this._changeLoginModal(false);
            } else {
              this.loading = false
              // showError(res.msg);
            }
          })
        } else {
          this.loading = false
        }
      });
    },


  },
}
</script>

<style scoped lang="less">
.login-detail {
  /*height: 600px;*/

  .ant-menu-item {
    width: 50%;
    text-align: center;
    margin-bottom: 10px;
  }

  .ant-menu-horizontal {
    border: none;
  }
}

.login-form-forgot {
  float: right;
  color: #999999;
}

.register {
  color: #999999;
}

.register:hover {
  color: #00CF8C;
}

.login-form-forgot:hover {
  color: #00CF8C;
}

.login-form-action {
  margin-bottom: 0;
}
</style>
